import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getCustomerDashboard } from './api';
import {
  CUSTOMER_DASHBOARD_OBJECT_REQUESTING,
  GET_CUSTOMER_DASHBOARD_SUCCESS,
  GET_CUSTOMER_DASHBOARD_REQUEST,
  RESET_CUSTOMER_DASHBOARD_ISFETCHING
} from './constants';

function* get() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_DASHBOARD_OBJECT_REQUESTING });
    const response = yield call(getCustomerDashboard);
    yield put({
      type: GET_CUSTOMER_DASHBOARD_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_DASHBOARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(GET_CUSTOMER_DASHBOARD_REQUEST, get);
}

export default function* customerDashboardSagas() {
  yield all([watchList()]);
}
